import { StandardInput } from 'components/forms/input';
import { IBasketItem } from 'lib/basket/types';
import { useBasket } from 'lib/hooks/basket/use-basket';
import currency from 'currency.js';
import { priceAfterDiscount } from 'lib/price-after-discount';

interface Props {
  productItem: IBasketItem<'product'>;
}
export const ProductBasketItem = ({ productItem }: Props) => {
  const [basket, modifyBasket] = useBasket();
  const originalPrice = productItem.data.price;

  const hasDiscountCode = !!basket.discount?.applies_to.includes(
    productItem.id
  );
  const discountCodeObject = basket.discount;

  let actualPrice: number = hasDiscountCode
    ? priceAfterDiscount(
        originalPrice,
        discountCodeObject.discount_value,
        discountCodeObject.is_fixed
      )
    : originalPrice - productItem.data.discount;

  return (
    <article className='grid grid-cols-4 gap-4'>
      <img
        src={productItem.data.product.image}
        alt={`image for ${productItem.data.product.title}`}
        className='col-span-1'
      />
      <section className='col-span-3 grid grid-cols-2'>
        <header className='col-span-1 mt-auto text-left flex flex-col'>
          <h3 className='line-clamp-2 mt-auto text-base'>
            {productItem.data.product.title}
          </h3>
          <span className='text-sm text-gray-600 italic'>
            Unit Price:{' '}
            {actualPrice != originalPrice ? (
              <>
                <span className='line-through text-gray-500'>
                  {' '}
                  {currency(originalPrice, {
                    fromCents: true,
                    symbol: '£',
                  }).format()}
                </span>{' '}
                <span>
                  {' '}
                  {currency(actualPrice, {
                    fromCents: true,
                    symbol: '£',
                  }).format()}
                </span>
              </>
            ) : (
              <>
                {currency(originalPrice, {
                  fromCents: true,
                  symbol: '£',
                }).format()}
              </>
            )}
          </span>
          <span className='text-gray-600 italic text-sm'>Merch</span>
        </header>
        <button
          className='col-span-1 ml-auto text-xs text-red-default hover:underline mb-auto'
          onClick={() =>
            modifyBasket({ type: 'remove', payload: productItem })
          }>
          remove
        </button>

        <StandardInput
          label='Quantity'
          type='number'
          name={`item_${productItem.id}_quantity`}
          id={`item_${productItem.id}_quantity`}
          bind={{
            value: productItem.data.quantity,
            onChange: (e) =>
              modifyBasket({
                type: 'adjust',
                payload: {
                  ...productItem,
                  data: {
                    ...productItem.data,
                    quantity: parseInt(e.target.value),
                  },
                },
              }),
          }}
          className='col-span-1 mt-auto text-left'
        />

        <div className='col-span-1 col-start-2'>
          <dl className='flex flex-col justify-end w-full h-full'>
            <dt className='ml-auto mt-auto'>Total:</dt>
            <dd className='font-bold lining-nums ml-auto '>
              {currency(actualPrice * productItem.data.quantity, {
                fromCents: true,
                symbol: '£',
              }).format()}
            </dd>
          </dl>
        </div>
      </section>
    </article>
  );
};
